import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { TextField } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';

const CustomDatePicker = ({ value, onChange, error, inputFormat, sx = {}, isLoading }) => {
  const validValue = dayjs.isDayjs(value) ? value : null;

  return (
    <>
      {isLoading ? (
        <Skeleton height={60} />
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={validValue}
            onChange={onChange}
            inputFormat={inputFormat}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!error}
                helperText={error}
                fullWidth
                aria-label="Select date"
              />
            )}
            sx={{
              width: '100%',
              ...sx,
            }}
          />
        </LocalizationProvider>
      )}
    </>
  );
};

CustomDatePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(dayjs), PropTypes.oneOf([null])]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  inputFormat: PropTypes.string.isRequired,
  sx: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default CustomDatePicker;
